function wrap(el, wrapper) {
	el.parentNode.insertBefore(wrapper, el);
	wrapper.appendChild(el);
}

function insertAfter(el, referenceNode) {
	referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}

function getIndex(el) {
	return el ? [...el.parentNode.children].indexOf(el) : false;
}
function offset(el) {
	let rect = el.getBoundingClientRect(), bodyElt = document.body;
	return {
		top: rect.top + bodyElt .scrollTop,
		left: rect.left + bodyElt .scrollLeft
	}
}